/**
 * Catálogo fijo de rubros empresariales (a qué se dedica la empresa).
 * Se guarda como `industry` (ID) en el documento de la empresa.
 * "Mandos Medios" y "Gerencia Operativa" son TIPOS DE PUESTO (process.roleType), no rubros.
 */

export const INDUSTRY_IDS = [
  'hospitality_food',
  'retail',
  'call_center',
  'general_operational',
  'administrative',
  'sales',
] as const;

export type IndustryId = (typeof INDUSTRY_IDS)[number];

export interface IndustryOption {
  id: IndustryId;
  label: string;
}

/** Rubros empresariales oficiales (NO agregar otros). */
export const INDUSTRIES: IndustryOption[] = [
  { id: 'hospitality_food', label: 'Hotelería y Restaurantes' },
  { id: 'retail', label: 'Retail / Tiendas' },
  { id: 'call_center', label: 'Call Center / Atención al Cliente' },
  { id: 'general_operational', label: 'Operativo General' },
  { id: 'administrative', label: 'Administrativo / Oficina' },
  { id: 'sales', label: 'Ventas' },
];

const LABEL_BY_ID = new Map(INDUSTRIES.map((i) => [i.id, i.label]));

/** Labels para valores legacy (empresas creadas cuando existían como rubro). */
const LEGACY_INDUSTRY_LABELS: Record<string, string> = {
  middle_management: 'Mandos Medios / Supervisión (migrar a Tipo de puesto)',
  operational_management: 'Gerencia Operativa (migrar a Tipo de puesto)',
};

/** Devuelve el label del rubro por ID, o el id si no existe. */
export function getIndustryLabel(id: string | null | undefined): string {
  if (!id) return '—';
  return LABEL_BY_ID.get(id as IndustryId) ?? LEGACY_INDUSTRY_LABELS[id] ?? id;
}

/** Comprueba si un string es un ID de rubro válido. */
export function isValidIndustryId(value: string): value is IndustryId {
  return INDUSTRY_IDS.includes(value as IndustryId);
}
